<script>
export default {
    name: 'GroupTitle',
    props: {
        title: {
            type: String,
            default: "分组标题",
        },
        position: {
            type: String,
            default: "left"
        }
    },
    render() {
        return (
            <div style={{textAlign: this.position}}>{this.title}</div>
        )
    }
}
</script>